import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {Divider} from "@mui/material";
import {useNavigate} from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import EditPersonalCarContent from "@/components/admin/EditPersonalCarContent";

const EditPersonalCar = () => {

    const navigate = useNavigate()

    return (
    <>
        <AppBar position="relative" sx={{background:'white', color:'black', boxShadow:'none', borderBottom:'1px solid #e3e3e3'}}>
            <Toolbar sx={{ml:10}}>
                <Typography variant="div" color="inherit" noWrap>
                    <IconButton onClick={() => {navigate('/user/dashboard/')} } aria-label="delete" size="large" sx={{borderRadius:'inherit'}}>
                        <KeyboardBackspaceIcon fontSize="inherit"/>
                    </IconButton>
                </Typography>
                <Divider orientation="vertical" flexItem sx={{margin:2}} />
                <Typography variant="div" color="inherit" noWrap>
                    Enregistrer un véhicule
                </Typography>
            </Toolbar>
        </AppBar>

        <EditPersonalCarContent />


    </>
        );
};

export default EditPersonalCar;